export function detailScreeningFund ($c) {
  var fundJson = $c.fundJson
  // block and block is && data
  // $c.optionData.id_list is not sort
  $c.screeningFundJson = []
  $c.screeningFundJsonChangeFlag = false
  // ====================================投資先
  var select_id_list = [101, 2] //投資分類, 投資先国
  selectStockDetailFundsByAndData(select_id_list, fundJson, $c)

  // ====================================パフォーマンス（1年）
  var tmpFundJsonChangeFlag = $c.screeningFundJsonChangeFlag
  var select_id_list = [1001, 1301, 1401, 1501] //レーティング, リターン, 標準偏差, シャープレシオ
  var tmp_fund_json = !$c.screeningFundJsonChangeFlag
    ? fundJson
    : $c.screeningFundJson
  $c.screeningFundJsonChangeFlag = false
  selectStockDetailFundsByAndData(select_id_list, tmp_fund_json, $c)
  select_id_list = [1701]
  if (!$c.screeningFundJsonChangeFlag) {
    selectStockDetailFundsByAndData(select_id_list, tmp_fund_json, $c)
  } else {
    selectStockDetailFundsByOrData(select_id_list, tmp_fund_json, $c)
  }
  // screeningFundJsonChangeFlag from true -> false(this) -> true
  if (!$c.screeningFundJsonChangeFlag && tmpFundJsonChangeFlag) {
    $c.screeningFundJsonChangeFlag = tmpFundJsonChangeFlag
  }

  // ====================================パフォーマンス（3年）
  tmpFundJsonChangeFlag = $c.screeningFundJsonChangeFlag
  var select_id_list = [1003, 1303, 1403, 1503] //レーティング, リターン, 標準偏差, シャープレシオ
  var tmp_fund_json = !$c.screeningFundJsonChangeFlag
    ? fundJson
    : $c.screeningFundJson
  $c.screeningFundJsonChangeFlag = false
  selectStockDetailFundsByAndData(select_id_list, tmp_fund_json, $c)
  select_id_list = [1703]
  if (!$c.screeningFundJsonChangeFlag) {
    selectStockDetailFundsByAndData(select_id_list, tmp_fund_json, $c)
  } else {
    selectStockDetailFundsByOrData(select_id_list, tmp_fund_json, $c)
  }
  // screeningFundJsonChangeFlag from true -> false(this) -> true
  if (!$c.screeningFundJsonChangeFlag && tmpFundJsonChangeFlag) {
    $c.screeningFundJsonChangeFlag = tmpFundJsonChangeFlag
  }

  // ====================================パフォーマンス（5年）
  tmpFundJsonChangeFlag = $c.screeningFundJsonChangeFlag
  var select_id_list = [1005, 1305, 1405, 1505] //レーティング, リターン, 標準偏差, シャープレシオ
  var tmp_fund_json = !$c.screeningFundJsonChangeFlag
    ? fundJson
    : $c.screeningFundJson
  $c.screeningFundJsonChangeFlag = false
  selectStockDetailFundsByAndData(select_id_list, tmp_fund_json, $c)
  select_id_list = [1705]
  if (!$c.screeningFundJsonChangeFlag) {
    selectStockDetailFundsByAndData(select_id_list, tmp_fund_json, $c)
  } else {
    selectStockDetailFundsByOrData(select_id_list, tmp_fund_json, $c)
  }
  // screeningFundJsonChangeFlag from true -> false(this) -> true
  if (!$c.screeningFundJsonChangeFlag && tmpFundJsonChangeFlag) {
    $c.screeningFundJsonChangeFlag = tmpFundJsonChangeFlag
  }

  // ====================================手数料
  var select_id_list = [3, 4, 5] //買付手数料, 信託報酬, 信託財産留保額
  var tmp_fund_json = !$c.screeningFundJsonChangeFlag
    ? fundJson
    : $c.screeningFundJson
  selectStockDetailFundsByAndData(select_id_list, tmp_fund_json, $c)

  // ====================================決算回数
  var select_id_list = [7]
  var tmp_fund_json = !$c.screeningFundJsonChangeFlag
    ? fundJson
    : $c.screeningFundJson
  selectStockDetailFundsByAndData(select_id_list, tmp_fund_json, $c)

  // ====================================さらに詳しい こだわり条件
  var select_id_list = [9, 6, 11, 12, 0] // 運用手法, 純資産総額, 運用期間, 償還期間, 運用会社
  var tmp_fund_json = !$c.screeningFundJsonChangeFlag
    ? fundJson
    : $c.screeningFundJson
  selectStockDetailFundsByAndData(select_id_list, tmp_fund_json, $c)

  // ====================================販売会社
  var tmp_fund_json = !$c.screeningFundJsonChangeFlag
    ? fundJson
    : $c.screeningFundJson
  selectStockDetailFundsBySellbank(tmp_fund_json, $c)

  $c.screeningResultFundJson = $c.screeningFundJson
}

function selectStockDetailFundsByAndData (select_id_list, fundData, $c) {
  var tmpFundData = fundData
  for (var i = 0; i < $c.optionData.id_list.length; i++) {
    var option_id = $c.optionData.id_list[i]
    var option_name = $c.optionData.name_list[i]
    var option_item_num = $c.optionData.item_num_list[i]
    if (select_id_list.indexOf(option_id) > -1) {
      $c.screeningFundJson = []
      $.each(tmpFundData, function (i, fund) {
        for (var key in fund) {
          if (fund[key] != '' && key == option_name) {
            for (var i = 0; i < option_item_num.length; i++) {
              if (option_item_num[i] == fund[key]) {
                $c.screeningFundJson.push(fund)
                $c.screeningFundJsonChangeFlag = true
              }
            }
          }
        }
      })
      tmpFundData = $c.screeningFundJson
    }
  }
}

function selectStockDetailFundsByOrData (select_id_list, fundData, $c) {
  let tmpFundData = fundData
  for (let i = 0; i < $c.optionData.id_list.length; i++) {
    let option_id = $c.optionData.id_list[i]
    let option_name = $c.optionData.name_list[i]
    let option_item_num = $c.optionData.item_num_list[i]
    if (select_id_list.indexOf(option_id) > -1) {
      $.each(tmpFundData, function (i, fund) {
        for (let key in fund) {
          if (fund[key] != '' && key == option_name) {
            for (let i = 0; i < option_item_num.length; i++) {
              if (option_item_num[i] == fund[key]) {
                if (option_id == 1701 && JSON.stringify(option_item_num) == '["1"]') {
                  continue;
                }
                $c.screeningFundJson.push(fund)
                $c.screeningFundJsonChangeFlag = true
              }
            }
          }
        }
      })
      break
    }
  }
}

function selectStockDetailFundsBySellbank (fundJson, $c) {
  var tmp_fund_json =
    $c.screeningFundJson.length == 0 ? fundJson : $c.screeningFundJson
  //  screening optionVal, and get screening fund list
  for (var i = 0; i < $c.optionData.id_list.length; i++) {
    var option_id = $c.optionData.id_list[i]
    var option_name = $c.optionData.name_list[i]
    var option_item_num = $c.optionData.item_num_list[i]
    // skip: 販売会社
    if (option_name.indexOf('販売') != -1) {
      var sell_bank_option_id = option_id
      var sell_bank_option_item_num = option_item_num
      var screeningSellBankFundIdJson = []
      if (sell_bank_option_id > -1) {
        // screening fund with sell bank option: screeningSellBankJson
        $c.screeningFundJson = []
        $.each($c.fundSellBankJson, function (i, fund) {
          $.each(sell_bank_option_item_num, function (j, bank_id) {
            if (
              fund[1] == bank_id &&
              $.inArray(fund[0], screeningSellBankFundIdJson) == -1
            ) {
              screeningSellBankFundIdJson.push(fund[0])
            }
          })
        })
        $.each(tmp_fund_json, function (i, fund) {
          for (var key in fund) {
            if (key == 'id_fund') {
              $.each(screeningSellBankFundIdJson, function (j, fund_id) {
                if (
                  fund[key] == fund_id &&
                  $.inArray(fund, $c.screeningFundJson) == -1
                ) {
                  $c.screeningFundJson.push(fund)
                  $c.screeningFundJsonChangeFlag = true
                }
              })
            }
          }
        })
      }
      break
    }
  }
}

// Get JSON
export function getJson(url, arr, opt) {
  if (!opt) {
    opt = {}
  }
  if (!opt.async) {
    opt.async = false
  }
  try {
    $.ajax({
      url: url,
      type: 'GET',
      async: opt.async,
      contentType: 'application/json;charset=utf8',
      success: function (data) {
        $.each(data, function (i, v) {
          arr.push(v)
        })
        if (opt.callback) {
          opt.callback(opt.callbackParams)
        }
      },
      error: function (data) {
        // loading.remove()
        console.log('エラーが発生しました', data)
      },
    })
  } catch (e) {
    console.log(e.name)
    console.log(e.message)
  }
}
